class ProductThumbnailComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = $(this);
    this.slider.slick({
      dots: false,
      arrows: true,
      infinite: false,

      autoplay: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      vertical: false,
      focusOnSelect: true,

      accessibility: false,

      slidesToShow: 6,
      slidesToScroll: 1,

      swipeToSlide: true,
      swiping: false,
      scrolling: false,
      //draggable: true,
      //cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
      //touchThreshold: 100,
      asNavFor: 'product-carousel-component',

      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 5
          }
        }]
    });
  }
}

customElements.define('product-thumbnail-component', ProductThumbnailComponent);
